import { config as appConfig } from "@/config";
"use strict";

import Vue from 'vue';
import axios from "axios";

// Uses cookies for authentication only
// const AUTH_TOKEN = localStorage.getItem('token');
// if (AUTH_TOKEN) {
//   axios.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;
// }

let config = {
  baseURL: appConfig.BASE_URL || process.env.apiUrl || "",
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // allow credentials to be send, including cookies in the request header
  crossorigin: true
};

const _axios = axios.create(config);


Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
